import { OrgTreeNodeType } from '../admin/organizations/org-tree-node-type';

export class OrgTreeNodeParentHistory {
  readonly friendlyTypeNameSingular = 'Org Tree Node Parent History';

  parentStartDate: Date;
  parentEndDate: Date;
  parentId: string;
  parentName: string;
  parentOrgTreeNodeType: OrgTreeNodeType;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.parentStartDate = data.parentStartDate;
    this.parentEndDate = data.parentEndDate;
    this.parentId = data.parentId;
    this.parentName = data.parentName;
    this.parentOrgTreeNodeType = data.parentOrgTreeNodeType;
  }
}
